import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  NgZone
} from "@angular/core";
import { FormService } from "../../services/form.service";
import { Platform } from "@ionic/angular";

@Component({
  selector: "header-score-display",
  templateUrl: "./header-score-display.component.html",
  styleUrls: ["./header-score-display.component.scss"],
  providers: [FormService]
})
export class HeaderScoreDisplayComponent implements OnInit {
  @Input() enabled:boolean
  @Input() formService:any
  @Input() formCurrentScore:number
  @Input() formMaxScore:any
  @Input() sectionInfo: any
  @Output() scoreSummaryChange = new EventEmitter<boolean>();

  showScoreSummary = false
  isMobile:boolean = false

  constructor(private platform: Platform) { 
    if(this.platform.is('ios') || this.platform.is('android')){
      this.isMobile = true
    };
  }

  
  toggleScoreSummary() {
    this.showScoreSummary = !this.showScoreSummary; 
    this.scoreSummaryChange.emit(this.showScoreSummary);
  }

  ngOnInit() {
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['sectionInfo']) {
  //     const currentValue = changes['sectionInfo'].currentValue;
  //     console.log('sectionInfo changed:', {
  //       currentValue
  //     });
  //   }
  // }
}
